import { MagnifyingGlassIcon } from '@heroicons/react/16/solid';
import { useDebouncedValue } from '@mantine/hooks';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { format } from 'date-fns';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import NavButton from '../../../../components/NavButton';
import { useModuleStore } from '../../../../components/moduleStore';
import constants from '../../../../constants';

const ClosedServiceRequests = () => {
	const [skip, setSkip] = useState(0);
	const [limit /*setLimit*/] = useState(10);
	const [order /*setOrder*/] = useState([]);
	const [searchVal, setSearchVal] = useState('');
	const searchValue = useDebouncedValue(searchVal, 250);
	const setServiceRequest = useModuleStore((state) => state.setServiceRequest);
	const dashboardQuery = useQuery({
		queryKey: ['worklist-completed', limit, skip, order, searchValue[0]],
		queryFn: async () => {
			const { data } = await axios.get(`/requests/worklist-completed`, {
				params: {
					options: {
						limit,
						skip,
						order,
						searchValue: searchValue[0],
					},
				},
			});
			return data;
		},
	});

	const handleOpenApplicationModules = (requestId) => {
		setServiceRequest(dashboardQuery.data.find(({ id }) => id == requestId));
	};

	const handlePrevious = () => {
		const newSkip = skip - limit;
		if (newSkip < 0) {
			setSkip(0);
		} else {
			setSkip(newSkip);
		}
	};

	const handleNext = () => {
		setSkip(skip + limit);
	};

	return (
		<div>
			<div className="mt-4 mb-4">
				<label className="flex items-center w-1/3 gap-2 input input-bordered input-sm">
					<MagnifyingGlassIcon className="w-5 h-5 opacity-70" />
					<input
						type="search"
						placeholder="Search by client name..."
						className="grow"
						value={searchVal}
						onChange={(e) => setSearchVal(e.target.value)}
					/>
				</label>
			</div>
			<table className="table table-zebra">
				<thead>
					<tr>
						<th>
							Created On
							{/* <ChevronUpDownIcon className="inline-block w-4 h-4" /> */}
						</th>
						<th>Client Name</th>
						<th>Referring Org</th>
						<th>Service</th>
						<th>Receiving Org</th>
						<th>Status</th>
						<td>App. Value</td>
						<th>Completed On</th>
					</tr>
				</thead>
				<tbody>
					{dashboardQuery.isFetching && (
						<tr>
							<td colSpan={6}>Loading...</td>
						</tr>
					)}
					{dashboardQuery.isFetched &&
						!dashboardQuery.isError &&
						dashboardQuery?.data.length === 0 && (
							<tr>
								<td colSpan={6}>No service requests found.</td>
							</tr>
						)}
					{dashboardQuery.isFetched &&
						!dashboardQuery.isError &&
						dashboardQuery.data.length > 0 &&
						dashboardQuery.data.map((serviceRequest) => (
							<tr key={`${serviceRequest.id}`}>
								<td>{format(new Date(serviceRequest.request_dttm), 'Pp')}</td>
								<td>
									{serviceRequest.name_first} {serviceRequest.name_last}
								</td>
								<td>{serviceRequest?.agency_name}</td>
								<td>{serviceRequest.taxonomy_detail}</td>
								<td>{serviceRequest?.rec_agency_name}</td>
								<td>
									{!isEmpty(serviceRequest.request_status) &&
										constants.status[serviceRequest.request_status]}
								</td>
								<td>
									{serviceRequest.app_dollar_value && (
										<>${serviceRequest.app_dollar_value}</>
									)}
								</td>
								<td>
									{!isEmpty(serviceRequest.completed_dttm) &&
										format(new Date(serviceRequest.completed_dttm), 'Pp')}
								</td>
								<td>
									<NavButton
										to={`/worklist/application/${serviceRequest.id}`}
										onClick={() =>
											handleOpenApplicationModules(serviceRequest.id)
										}
										title="View"
									/>
								</td>
							</tr>
						))}
				</tbody>
			</table>
			<div className="flex justify-end p-4 ">
				<div className="grid grid-cols-2 w-72 join">
					<button
						className="join-item btn btn-outline btn-secondary"
						disabled={skip === 0}
						onClick={handlePrevious}
					>
						Previous page
					</button>
					<button
						className="join-item btn btn-outline btn-secondary"
						disabled={dashboardQuery?.data?.length < limit}
						onClick={handleNext}
					>
						Next page
					</button>
				</div>
			</div>
		</div>
	);
};

export default ClosedServiceRequests;
